/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-console */
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import './Reiter.css';

function Reiter({
  id, bilddaten, downloadGames, viewportWidth, daten,
}) {
  const tempLinkPlayInBrowser = `https://im-srv9.hdm-stuttgart.de/webspace/${daten[0].projekt_ID}/`;

  // STATES
  const [needDownloadReiter, setNeedDownloadReiter] = useState(false);
  const [thereIsWeb, setThereIsWeb] = useState(false);

  // FUNCTIONS
  /*
  -------------------
  Download vorhanden?
  -------------------
  */
  // eslint-disable-next-line no-shadow
  function checkIfWeNeedDownload(downloadGames) {
    let numObjects = 0;
    if (downloadGames.length >= 1) {
      for (let i = 0; i < downloadGames.length; i += 1) {
        const pathname = `${downloadGames[i].file_name}`;
        const temppathname = pathname.substring(pathname.length - 7, pathname.length - 4);

        numObjects += 1;
        if (temppathname.localeCompare('web') === 0) {
          setThereIsWeb(true);
        }
      }
    }

    if (thereIsWeb === true && numObjects === 1) {
      setNeedDownloadReiter(false);
    } else {
      setNeedDownloadReiter(true);
    }
  }

  // EFFECTS
  useEffect(() => {
    checkIfWeNeedDownload(downloadGames);
  }, [downloadGames]);

  // RENDER
  return (
    <div className={viewportWidth > 768 ? 'reiter' : 'reiter-mobil'}>
      <NavLink
        to={`/mediathek/projectpage/${id}/details`}
        className={
          viewportWidth > 768
            ? 'reiter_einzeln_details'
            : 'reiter_einzeln_details_mobil'
        }
        activeClassName="reiter_einzeln_active"
      >
        Details
      </NavLink>
      <NavLink
        to={`/mediathek/projectpage/${id}/team`}
        className={
          viewportWidth > 768 ? 'reiter_einzeln' : 'reiter_einzeln_mobil'
        }
        activeClassName="reiter_einzeln_active"
      >
        Team
      </NavLink>
      <NavLink
        to={`/mediathek/projectpage/${id}/teilen`}
        className={
          viewportWidth > 768 ? 'reiter_einzeln' : 'reiter_einzeln_mobil'
        }
        activeClassName="reiter_einzeln_active"
      >
        Teilen
      </NavLink>
      {bilddaten.length >= 1 ? (
        <NavLink
          to={`/mediathek/projectpage/${id}/bilder`}
          className={
            viewportWidth > 768 ? 'reiter_einzeln' : 'reiter_einzeln_mobil'
          }
          activeClassName="reiter_einzeln_active"
        >
          Bilder
        </NavLink>
      ) : null}
      {daten[0 % daten.length].weblinks.length >= 1 ? (
        <NavLink
          to={`/mediathek/projectpage/${id}/links`}
          className={
          viewportWidth > 768 ? 'reiter_einzeln' : 'reiter_einzeln_mobil'
        }
          activeClassName="reiter_einzeln_active"
        >
          Links
        </NavLink>
      ) : null}
      {downloadGames.length >= 1 && needDownloadReiter === true && viewportWidth > 768 ? (
        <NavLink
          to={`/mediathek/projectpage/${id}/download`}
          className={
            viewportWidth > 768 ? 'reiter_einzeln' : 'reiter_einzeln_mobil'
          }
          activeClassName="reiter_einzeln_active"
        >
          Downloads
        </NavLink>
      ) : null}
      {// Jetzt Spielen nur auf Desktop - viele Spiele sind nicht mobil- oder touchoptimiert.
      daten[0].webspace === 2 && viewportWidth > 768 ? (
        <a
          href={tempLinkPlayInBrowser}
          target="_blank"
          rel="noopener noreferrer"
          className={
            viewportWidth > 768 ? 'reiter_einzeln_playable' : 'reiter_einzeln_mobil_playable'
          }
        >
          Jetzt Spielen
        </a>
      ) : null
}
    </div>
  );
}

export default Reiter;

Reiter.propTypes = {
  id: PropTypes.number.isRequired,
  daten: PropTypes.any.isRequired,
  downloadGames: PropTypes.any.isRequired,
  bilddaten: PropTypes.any.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
